import React from 'react'

import Navbar from '../../components/navbar/Navbar'

import style from './TeacherHome.module.css'

import { useNavigate } from 'react-router-dom'

const TeacherHome = () => {

    const navigate = useNavigate()

  return (

     <>

     <Navbar />

     <div className={style.container}>

        <div className={style.tile}>

        <div className={style.tileBody}>

        <button type="button" onClick={() => navigate('/students') }>My Students</button>

        </div>

        </div>

        <div className={style.tile}>

        <div className={style.tileBody}>

        <button type="button" onClick={() => navigate('/classes')} >Classes</button>

        </div>

        </div>

        <div className={style.tile}>

        <div className={style.tileBody}>

        <button type="button" onClick={() => navigate("/books")}>Books</button>

        </div>

        </div>

     </div>



    </>

  )

}



export default TeacherHome
